import './redwinggolfclub/style';
import FormStructure from './redwinggolfclub/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/includes.js